module.exports = __webpack_public_path__ + "static/media/wechat.b50dacef.svg";